import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export const StudyProgramRatingSystemList = {
  data() {
    return {
      ratingSystemList: [
        { text: '/5', id: Consts.RATING_SYSTEM_STUDY_FIVE },
        { text: '/10', id: Consts.RATING_SYSTEM_STUDY_TEN },
        { text: '/20', id: Consts.RATING_SYSTEM_STUDY_TWENTY },
        { text: '/100', id: Consts.RATING_SYSTEM_STUDY_HUNDRED },
        { text: i18n.instance().t('study-rating-system-other'), id: Consts.RATING_SYSTEM_STUDY_OTHER }
      ]
    }
  },
  methods: {
    getStudyProgramRatingSystemFacetLabel: function(rating) {
      return `${this.ratingSystemList.filter(x => x.id === rating.value.toString()).first().text} (${rating.count})`
    },
    getStudyProgramRatingSystemLabelById: function(id) {
      return this.ratingSystemList.filter(x => x.id === id).first().text
    }
  }
}
